import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaArrowRight,
  FaShoppingBag,
  FaFileInvoice
} from "react-icons/fa";

const Footer = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "https://api.glamiraa.in/companyDetails"
        );
        setData(res.data.data);
      } catch (error) {}
    };

    fetchData();
  }, []);

  return (
    <>
      <footer
        className="text-light pt-5"
        style={{
          background:
            "linear-gradient(135deg,#0f172a,#1e293b,#111827)",
        }}
      >
        <div className="container">

          {/* Top CTA */}

          <div
            className="row align-items-center rounded-4 p-4 mb-5"
            style={{
              background:
                "linear-gradient(135deg,#2563eb,#4f46e5,#7c3aed)",
            }}
          >
            <div className="col-lg-8">
              <h2 className="fw-bold text-white mb-2">
                Discover Amazing Products Every Day
              </h2>

              <p className="text-white mb-0" style={{ opacity: 0.9 }}>
                Shop smarter with premium collections, exclusive deals, and
                secure checkout.
              </p>
            </div>

            <div className="col-lg-4 text-lg-end mt-3 mt-lg-0">
              <Link
                to="/shop"
                className="btn btn-warning rounded-pill px-4 py-2 fw-semibold"
              >
                Shop Now <FaArrowRight className="ms-2" />
              </Link>
            </div>
          </div>

          {/* Main Footer */}

          <div className="row gy-5">

            {/* Brand */}

            <div className="col-lg-4">

              <div className="d-flex align-items-center mb-3">
                <FaShoppingBag
                  size={32}
                  className="text-warning me-2"
                />

                <h3 className="fw-bold m-0">
                  Glamira
                </h3>
              </div>

              <p
                className="text-light"
                style={{ opacity: 0.8, lineHeight: "30px" }}
              >
                Glamira is your trusted online shopping destination,
                offering premium quality products, secure payments,
                fast delivery, and exceptional customer service.
              </p>
            </div>

            {/* Quick Links */}

            <div className="col-lg-2 col-md-6">

              <h5 className="fw-bold mb-4">
                Quick Links
              </h5>

              <ul className="list-unstyled">

                <li className="mb-3">
                  <Link
                    className="text-decoration-none text-light footer-link"
                    to="/"
                  >
                    Home
                  </Link>
                </li>

                <li className="mb-3">
                  <Link
                    className="text-decoration-none text-light footer-link"
                    to="/about"
                  >
                    About Us
                  </Link>
                </li>

                <li className="mb-3">
                  <Link
                    className="text-decoration-none text-light footer-link"
                    to="/shop"
                  >
                    Shop
                  </Link>
                </li>

                <li className="mb-3">
                  <Link
                    className="text-decoration-none text-light footer-link"
                    to="/contact"
                  >
                    Contact
                  </Link>
                </li>

              </ul>

            </div>

            {/* Customer */}

            <div className="col-lg-3 col-md-6">

              <h5 className="fw-bold mb-4">
                Customer Care
              </h5>

              <ul className="list-unstyled">

                <li className="mb-3">
                  <Link
                    to="/privacy-policy"
                    className="text-decoration-none text-light footer-link"
                  >
                    Privacy Policy
                  </Link>
                </li>

                <li className="mb-3">
                  <Link
                    to="/terms-conditions"
                    className="text-decoration-none text-light footer-link"
                  >
                    Terms & Conditions
                  </Link>
                </li>

                <li className="mb-3">
                  <Link
                    to="/refund-policy"
                    className="text-decoration-none text-light footer-link"
                  >
                    Refund Policy
                  </Link>
                </li>

                <li className="mb-3">
                  <Link
                    to="/faq"
                    className="text-decoration-none text-light footer-link"
                  >
                    FAQs
                  </Link>
                </li>

              </ul>

            </div>

            {/* Contact */}

            <div className="col-lg-3">

              <h5 className="fw-bold mb-4">
                Contact Information
              </h5>

              {/* {data.map((item) => (
                <div key={item.site_id}>

                  <div className="d-flex mb-3">

                    <FaMapMarkerAlt
                      className="me-3 mt-1 text-warning"
                      style={{
                        width: "100px"
                      }}
                    />

                    <div>
                      <strong>{item.company_Name}</strong>
                      <br />
                      <small style={{ opacity: 0.8 }}>
                        {item.address}
                      </small>
                    </div>

                  </div>

                  <div className="d-flex mb-3">

                    <FaEnvelope
                      className="me-3 mt-1 text-warning"
                    />

                    <span>{item.contact_email}</span>

                  </div>

                  <div className="d-flex">

                    <FaPhoneAlt
                      className="me-3 mt-1 text-warning"
                    />

                    <span>{item.contact_phone}</span>

                  </div>

                </div>
              ))} */}


              {data.map((item) => (
                <div key={item.site_id}>
                  
                  <div className="d-flex mb-3">
                    <FaMapMarkerAlt
                      className="me-3 mt-1 text-warning"
                      style={{ width: "100px" }}
                    />
                    <div>
                      <strong>{item.company_Name}</strong>
                      <br />
                      <small style={{ opacity: 0.8 }}>
                        {item.address}
                      </small>
                    </div>
                  </div>

                  <div className="d-flex mb-3">
                    <FaEnvelope className="me-3 mt-1 text-warning" />
                    <span>{item.contact_email}</span>
                  </div>

                  <div className="d-flex mb-3">
                    <FaPhoneAlt className="me-3 mt-1 text-warning" />
                    <span>{item.contact_phone}</span>
                  </div>

                  {/* GST Number */}
                  <div className="d-flex align-items-center mt-3">
                    <FaFileInvoice className="text-warning me-3" />
                    <span
                      style={{
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                    >
                      <span style={{ color: "#ffc107", fontWeight: "600" }}>
                        GSTIN:
                      </span>{" "}
                      {item.gst_number}
                    </span>
                  </div>

                </div>
              ))}

            </div>

          </div>

          {/* Divider */}

          <hr
            className="my-5"
            style={{
              borderColor: "rgba(255,255,255,.15)",
            }}
          />

          {/* Bottom */}

          <div className="row align-items-center pb-4">

            <div className="col-md-6 text-center text-md-start">

              <p className="mb-0" style={{ opacity: 0.8 }}>
                © {new Date().getFullYear()} Glamira. All Rights Reserved.
              </p>

            </div>

            <div className="col-md-6 text-center text-md-end mt-3 mt-md-0">

              <span
                className="me-3"
                style={{ opacity: 0.8 }}
              >
                Secure Payments
              </span>

              <span
                className="me-3"
                style={{ opacity: 0.8 }}
              >
                Fast Delivery
              </span>

              <span style={{ opacity: 0.8 }}>
                24/7 Support
              </span>

            </div>

          </div>

        </div>
      </footer>
    </>
  );
};

export default Footer;